import React, {
    useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { CurrencyValue, Link } from '@jutro/components';
import htmlParser from 'html-react-parser';
import CommonConstants from 'sg-common-constants';
import { SgCepChanges, SgDocumentsUtil, SgActiveTestsContext } from 'saga-modules';
import messages from './SgRenewalPremium.messages';

function SgRenewalPremium(props) {
    const {
        renewalDetails,
        hasRenewalChanges
    } = props;
    const MONTHLY = 'monthly';
    const QUARTERLY = 'quarterly';
    const QUARTERLY_INSTALLMENTS_THRESHOLD = 3;

    const translator = useContext(TranslatorContext);
    const { activeMvtTests } = useContext(SgActiveTestsContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';
    const contactUsPhoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_CEP_RENEWAL_COVER_LEVELS_PHONE_NUMBER;
    const contactUsPhoneNumber2 = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_HELP_DESK_MOTOR_PHONE_NUMBER2;

    return (
        <div className="sgRenewalPremiumBox">
            <div className="sgRenewalPremiumContainer">
                <span className="sgPremiumLabel">
                    {hasRenewalChanges ? translator(messages.PremiumLabelWithChanges) : translator(messages.PremiumLabel)}
                </span>
                <div id="amountForRenewal">
                    <span className="sgPremiumAmount">
                        <CurrencyValue
                            currency="gbp"
                            currencyDisplay="symbol"
                            id="CurrencyValue"
                            placeholder="-"
                            showGrouping
                            showFractions
                            tag="span"
                            value={renewalDetails.premium.amount}
                        />
                    </span>
                </div>
            </div>
            <div className="sgPremiumAmountPrevious">
                <span>{hasRenewalChanges ? translator(messages.PreviousPremiumLabelWithChanges) : translator(messages.PreviousPremiumLabel)}</span>
                &nbsp;
                <span id="currentPremium">
                    <CurrencyValue
                        currency="gbp"
                        currencyDisplay="symbol"
                        id="CurrencyValue"
                        placeholder="-"
                        showGrouping
                        showFractions
                        tag="span"
                        value={hasRenewalChanges ? SgCepChanges.getPreviousCost() : renewalDetails.currentPremium.amount}
                    />
                </span>
            </div>
            { renewalDetails.installmentsInfo_Ext
                && (
                    <div id="renewalInstallmentsInfo">
                        <div id="firstInstalment">
                            <div id="firstInstallmentLabel">{translator(messages.FirstInstallmentLabel)}</div>
                            <CurrencyValue
                                currency="gbp"
                                currencyDisplay="symbol"
                                id="firstInstallmentValue"
                                placeholder="-"
                                showGrouping
                                showFractions
                                tag="span"
                                value={renewalDetails.installmentsInfo_Ext.firstInstallmentAmount}
                            />
                        </div>
                        <div id="restInstalments">
                            <div id="restInstalmentsLabel">
                                {translator(messages.RemainingInstallmentLabel, {
                                    numberOfInstallments: renewalDetails.installmentsInfo_Ext.numberOfInstallmentsWithoutFirst,
                                    period: renewalDetails.installmentsInfo_Ext.numberOfInstallmentsWithoutFirst > QUARTERLY_INSTALLMENTS_THRESHOLD
                                        ? MONTHLY : QUARTERLY
                                })}
                            </div>
                            <CurrencyValue
                                currency="gbp"
                                currencyDisplay="symbol"
                                id="restInstalmentsValue"
                                placeholder="-"
                                showGrouping
                                showFractions
                                tag="span"
                                value={renewalDetails.installmentsInfo_Ext.installmentAmount}
                            />
                        </div>
                        { renewalDetails.installmentsInfo_Ext.chargeForCredit.amount > 0
                        && (
                            <div>
                                <span id="renewalApproximation">{translator(messages.ChargeForCreditLabel)}</span>
                                <CurrencyValue
                                    currency="gbp"
                                    currencyDisplay="symbol"
                                    id="creditCharge"
                                    placeholder="-"
                                    showGrouping
                                    showFractions
                                    tag="span"
                                    value={renewalDetails.installmentsInfo_Ext.chargeForCredit}
                                />
                                <span id="renewalApproximation">
                                    {translator(messages.APRLabel, { apr: renewalDetails.installmentsInfo_Ext.apr })}
                                </span>
                            </div>
                        )
                        }
                    </div>
                )
            }
            { renewalDetails.termNumber <= 3
                && (
                    <p className="sg-cep-summary-cover-review-text">
                        <span id="shopAroundLessThanThree">{translator(messages.ShopAroundLessThanThreeLabel)}</span>
                    </p>
                )}
            { renewalDetails.termNumber >= 4
                && (
                    <p className="sg-cep-summary-cover-review-text">
                        <span id="shopAroundMoreThanFour">{translator(messages.ShopAroundMoreThanFourLabel)}</span>
                    </p>
                )}
            { !activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143) && !hasRenewalChanges && (
                <p id="confirmRenewalWording">
                    {translator(messages[`${renewalDetails.productCode}ComprehensiveCoverLabel`], {
                        phoneNumber1: isMobile
                            ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                            : <b>{contactUsPhoneNumber}</b>,
                        phoneNumber2: isMobile
                            ? <a href={`tel:${contactUsPhoneNumber2.replaceAll(' ', '')}`}>{contactUsPhoneNumber2}</a>
                            : <b>{contactUsPhoneNumber2}</b>
                    })}
                </p>
            )}
            { !activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143) && !renewalDetails.isCashChequePayment && !hasRenewalChanges
                && <p id="byClickingAccept">{htmlParser(translator(messages.ClickingAcceptLabel))}</p>
            }
            { (!activeMvtTests.includes(CommonConstants.ACTIVE_MVT_TESTS.WOC_3143) || hasRenewalChanges) && !renewalDetails.isCashChequePayment
               && (
                   <p id="confirmRenewalWording">
                       {translator(messages.ConfirmRenewalLabel)}
                       {(renewalDetails.renewalDocument) && (
                           <Link
                               href="/"
                               id="downloadRenewalDocuments"
                               onClick={(event) => SgDocumentsUtil.downloadDocument(
                                   event,
                                   renewalDetails.renewalDocument.policyNumber,
                                   renewalDetails.renewalDocument.sagaType
                               )}
                           >
                               {translator(messages.RenewalDocumentLabel)}
                           </Link>
                       )}
                   </p>
               )
            }

        </div>

    );
}

export default SgRenewalPremium;
